"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useDeepComparisonMemoize_1 = __importDefault(require("./useDeepComparisonMemoize"));
function useDeepComparisonMemo(react, factory, deps) {
    return react.useMemo(factory, deps === null || deps === void 0 ? void 0 : deps.map(dep => (0, useDeepComparisonMemoize_1.default)(react, dep)));
}
exports.default = useDeepComparisonMemo;
